import { render, staticRenderFns } from "./answer-collect.vue?vue&type=template&id=593a8232&scoped=true&"
import script from "./answer-collect.vue?vue&type=script&lang=js&"
export * from "./answer-collect.vue?vue&type=script&lang=js&"
import style0 from "./answer-collect.vue?vue&type=style&index=0&id=593a8232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a8232",
  null
  
)

export default component.exports